const scrollData = (e, ls) => {
  const bodyOffset = document.body.offsetTop - window.scrollY;
  return {
    time: e.timeStamp,
    scrollY: -bodyOffset,
    direction: ls > -bodyOffset ? 'up' : 'down',
  };
};

export default scrollData;
